import React from 'react';
import logo from '../assets/logo.png';
import darkLogo from '../assets/logo-dark.png';
import { useTheme } from '../lib/ThemeContext';

export function GreatLeapLogoIcon({ size = 36, customStyle = {}, variant = 'auto' }) {
  const { theme } = useTheme();
  const showDark = variant === 'dark' || (variant === 'auto' && theme === 'dark');

  const imgStyle = { width: '100%', height: '100%', objectFit: 'contain', display: 'block', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 };

  return (
    <div style={{ height: size, width: size * 3.2, flexShrink: 0, position: 'relative', ...customStyle }}>
      <img src={logo}     alt="Great Leap Logo" style={{ ...imgStyle, opacity: showDark ? 0 : 1 }} />
      <img src={darkLogo} alt="Great Leap Logo" style={{ ...imgStyle, opacity: showDark ? 1 : 0 }} />
    </div>
  );
}

